var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"relative"},[_c('div',{class:[{ 'btn-close': _vm.showMenu }, 'btn relative'],on:{"click":function($event){_vm.showMenu = !_vm.showMenu}}},[_c('span'),_c('span'),_c('span')]),_c('div',{class:[
            { 'active-mobile-nav': _vm.showMenu },
            'custom-mobile-nav overflow',
        ]},[_c('ul',{},_vm._l((_vm.navList),function(item,index){return _c('li',{key:index,class:[
                    { 'li-active': index === _vm.activeNum },
                    'transition',
                ],on:{"click":function($event){return _vm.navigateToTarget(item.name, index)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }